module.exports = __webpack_public_path__ + "d07f049f2a0aa8fc46a842cf4bb4fa90.pdf";